/**
 * Represents the current step (and visibility) of the free trial flow.
 * When Closed, no modal is shown. Otherwise the corresponding step modal is shown.
 */
export enum FreeTrialStep {
  Closed = 'closed',
  TrialDetails = 'trial-details',
  GrantAccess = 'grant-access',
  TrialEnded = 'trial-ended',
}

export enum BillingPeriodUnit {
  Month = 'month',
  Year = 'year',
}

export interface AddonGetTrialApiResponse {
  amountPerUnit: number;
  numberOfTrialDays: number;
  currencyCode: string;
  quantityApplicableForTrial: number;
  period: number;
  periodUnit: BillingPeriodUnit;
}

export const formatBillingPeriod = (period: number, periodUnit: BillingPeriodUnit): string => {
  if (periodUnit === BillingPeriodUnit.Year && period === 1) return 'per license per year';
  if (periodUnit === BillingPeriodUnit.Month && period === 1) return 'per license per month';
  if (periodUnit === BillingPeriodUnit.Month && period === 3) return 'per license per quarter';
  if (periodUnit === BillingPeriodUnit.Month && period === 6) return 'per license per half year';
  return `per license per ${period} ${periodUnit}${period > 1 ? 's' : ''}`;
};

export interface AddonPostTrialApiResponse {
  subscriptionId: string;
  addonPriceId: string;
  trialEndsAt: string;
  quantity: number;
}

export interface AssignLicensesRequest {
  licenses: LicenseUser[];
}

export interface LicenseUser {
  userId: string;
}
